export const DEV_TOKEN_STORAGE_KEY = "seeft-dev-token";

export function getStoredDevToken(): string | null {
  try {
    const value = localStorage.getItem(DEV_TOKEN_STORAGE_KEY)?.trim();
    return value ? value : null;
  } catch {
    return null;
  }
}

export function setStoredDevToken(value: string): void {
  try {
    const trimmed = value.trim();
    if (!trimmed) {
      localStorage.removeItem(DEV_TOKEN_STORAGE_KEY);
      return;
    }
    localStorage.setItem(DEV_TOKEN_STORAGE_KEY, trimmed);
  } catch {
    // localStorage unavailable
  }
}

export function clearStoredDevToken(): void {
  try {
    localStorage.removeItem(DEV_TOKEN_STORAGE_KEY);
  } catch {
    // localStorage unavailable
  }
}
